const prodContainerEl = qs('.product')
const thumbnails = qsa('.product__thumbnail')
const productImageContainer = qs('.product__image-container')
let productImageEl = qs('.product__image')
const swatchEls = qsa('.product__colors .swatch')
const descriptionEl = qs('.product__description')
const shippingMonthSelectEl = qs('.product__shipping-months-select')
const colorNameEl = qs('.product__option-title b')
const buyButtonEl = qs('.product__buy')
const errorEl = qs('.product__error')
const productSwiper = qs('.product__swiper')
const isDeposit = product.handle === 'hearth-display-deposit'
let fancySelect = null
let isLoading = false

const currentShippingVariantName = Object.values(variantsByOption).filter((variant) => {
  return !'JanuaryFebruaryMarchAprilMayJuneJulyAugustSeptemberOctoberNovemberDecember'.includes(variant.option2)
})[0].option2

// --- BEGIN: New swatch → hidden input sync ---
const atcFormEl =
  prodContainerEl.querySelector('form[action*="/cart/add"]') ||
  prodContainerEl.querySelector('[id^="add-to-cart-form"]');

const hiddenIdEl = atcFormEl?.querySelector('input[name="id"]');
const buyBtnEl   = buyButtonEl; // already defined above

function getSelectedVariantFromSwatches() {
  // Read your new radios inside fieldsets.swatches[data-option-position]
  const byPos = {};
  prodContainerEl.querySelectorAll('.swatches').forEach(fs => {
    const pos = Number(fs.getAttribute('data-option-position'));
    const checked = fs.querySelector('input[type="radio"]:checked');
    if (checked) byPos[pos] = checked.value;
  });

  const o1 = byPos[1], o2 = currentShippingVariantName, o3 = byPos[3];
  // Match against real product variants (Shopify guarantees option1..3)
  return product.variants.find(v =>
    (o1 == null || v.option1 === o1) &&
    (o2 == null || v.option2 === o2) &&
    (o3 == null || v.option3 === o3)
  ) || null;
}

function syncHiddenIdFromSwatches() {
  const v = getSelectedVariantFromSwatches();
  if (!v) return;
  if (hiddenIdEl) hiddenIdEl.value = v.id;        // <-- for TriplePixel (capture-phase)
  if (buyBtnEl)   buyBtnEl.dataset.variantId = v.id; // optional, also read by tracker
}

// Initial sync once DOM is ready
syncHiddenIdFromSwatches();

// Keep in sync on any radio change (BEFORE the click happens)
prodContainerEl.addEventListener('change', (e) => {
  if (e.target.matches('.swatches input[type="radio"]')) {
    syncHiddenIdFromSwatches();
  }
});
// --- END: New swatch → hidden input sync ---


// A/B test Description
if(typeof showAltDescription !== 'undefined' && showAltDescription){
  descriptionEl.innerHTML = altDescription
}


thumbnails.forEach(thumbnail => {
  thumbnail?.addEventListener('click', () => setProductImage(thumbnail))
})

setProductImage(thumbnails[0])

function setProductImage(thumbnail){
  const fullSource = thumbnail?.dataset.full
  const hasFrame = thumbnail?.classList.contains('has-frame')
  const newImageEl = ce({
    type: 'img',
    classname: 'product__image',
    listeners: {
      load: () =>{
        requestAnimationFrame(()=>{
          productImageEl.replaceWith(newImageEl)
          productImageEl = newImageEl

          if(hasFrame){
            productImageContainer.classList.add('has-frame')
          } else{
            productImageContainer.classList.remove('has-frame')
          }
          forceLayout()
          requestAnimationFrame(()=>{
            newImageEl.classList.add('is-loaded')
          })
        })
      }
    }
  })

  newImageEl.src = fullSource

  thumbnails.forEach(thumb=>{
    if(thumb === thumbnail){
      thumb.classList.add('is-current')
    } else {
      thumb.classList.remove('is-current')
    }
  })
}

swatchEls.forEach(swatch => {
  const inputEl = qs('.swatch__input', swatch)
  inputEl.addEventListener('change', ()=>{
    productSwiper.swiper.slideTo(0)
    if(inputEl.checked){
      const frameContainers = qsa('.has-frame')
      frameContainers.forEach(el => el.setAttribute('data-color', swatch.dataset.color))
      colorNameEl.innerHTML = inputEl.value
    }
    updateOptions()
  })
})

if(shippingMonthSelectEl){
  fancySelect = NiceSelect.bind(shippingMonthSelectEl)
  shippingMonthSelectEl.addEventListener('change',()=>fancySelect.update())
}

function updateOptions(){
  const shippingWindowSelectEl = qs('.product__shipping-months-select')
  const shippingMonthOptions = qsa('option',shippingWindowSelectEl)

  // See if any swatches are totally sold out
  swatchEls.forEach((swatch, index) => {
    const inputEl = qs('.swatch__input', swatch)
    const color = inputEl.value
    let soldOut = true

    Object.values(variantsByOption).filter(variant => variant.options.includes(color)).forEach(variant=>{
      if(variant.available) soldOut = false
    })

    if(soldOut){
      swatch.classList.add('is-disabled')
      inputEl.disabled = true

      if(inputEl.checked){
        const next = index === swatchEls.length - 1 ? 0 : index + 1
        qs('.swatch__input', swatchEls[next]).click()
      }
    }
  })
  
  // Get selected color
  const currentColor = getCurrentColor()

  // See if any shipping windows are sold out
  shippingMonthOptions?.forEach(option =>{
    if(option.value === 'select') return

    const id = `${currentColor}${option.value}`
    const soldOut = !variantsByOption[id].available


    if(soldOut){
      option.disabled = true
      option.innerHTML = `${option.value} — Sold Out`
    } else if(option.disabled) {
      option.disabled = false
      option.innerHTML = `${option.value}`
    }
  })

  const firstAvailable = shippingMonthOptions ? Array.from(shippingMonthOptions).reduce((acc, curr) => {
    if(acc) return acc
    return !curr.disabled ? curr : acc
  }, null) : null
  
  if(firstAvailable){
    shippingWindowSelectEl.value = firstAvailable.value
    firstAvailable.selected = true
  }

  fancySelect?.update()
}

function getCurrentColor(){
  return Array.from(swatchEls).reduce((acc,curr) => {
    const inputEl = qs('.swatch__input', curr)
    return inputEl.checked ? inputEl.value : acc
  }, null)
}

function showError(error){
  errorEl.classList.add('is-visible')
  errorEl.innerHTML = error
}


async function submit() {
  if (isLoading) return;
  isLoading = true;
  prodContainerEl.classList.add('is-loading');

  try {
    syncHiddenIdFromSwatches();

    // Intentar obtener variante de los swatches
    let selectedVariant = getSelectedVariantFromSwatches();

    // Si no hay variante o no está disponible, buscar la primera disponible del color
    if (!selectedVariant || !selectedVariant.available) {
      const currentColor = getCurrentColor();
      // Priorizar "Ready to Ship", luego cualquier disponible
      selectedVariant = product.variants.find(v => 
        v.option1 === currentColor && 
        v.option2 === 'Ready to Ship' && 
        v.available
      ) || product.variants.find(v => 
        v.option1 === currentColor && 
        v.available
      ) || null;
    }

    if (!selectedVariant || !selectedVariant.available) {
      showError('Sorry, this color is currently sold out.');
      return;
    }

    if (hiddenIdEl) hiddenIdEl.value = selectedVariant.id;
    if (buyBtnEl) buyBtnEl.dataset.variantId = selectedVariant.id;

    try {
      const response = await setCart([{ id: Number(selectedVariant.id) }]);
      if (response?.status === 'ERROR') throw new Error('setCart returned ERROR');
    } catch (e) {
      const res = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: Number(selectedVariant.id), quantity: 1 })
      });
      if (!res.ok) {
        const t = await res.text();
        throw new Error('cart/add.js failed: ' + t);
      }
    }

  } catch (error) {
    console.error('[ATC] submit() error:', error);
    showError('Sorry, something went wrong adding to cart.');
  } finally {
    prodContainerEl.classList.remove('is-loading');
    isLoading = false;
  }
}


/*
async function submit(){
  if(isLoading) return
  isLoading = true
  prodContainerEl.classList.add('is-loading')
  const currentColor = getCurrentColor()
  const selectedVariant = variantsByOption[`${currentColor}${currentShippingVariantName}`]
  const selectedMembershipVariant = membershipProducts?.[membershipSelectEl?.value]?.variants[0]
  const membershipSellingPlandId = selectedMembershipVariant?.selling_plan_allocations?.[0]?.selling_plan_id


  try {
    const membershipProduct = selectedMembershipVariant ? [{id: selectedMembershipVariant.id, sellingPlanId: membershipSellingPlandId}] : []
    const response = await setCart([...membershipProduct, {id: selectedVariant.id}])
    prodContainerEl.classList.remove('is-loading')
    isLoading = false

    if(response?.status === 'ERROR'){
      console.log(response)
      sessionStorage.setItem('cart-error', `Sorry, ${currentColor} is sold out. Please try again with other options.`)
      location.reload()
    }
  } catch (error) {
    prodContainerEl.classList.remove('is-loading')
    isLoading = false
    console.log(error)
  }
}*/

async function submitDeposit(){
  if(isLoading) return
  isLoading = true
  prodContainerEl.classList.add('is-loading')
  const selectedVariant = variantsByOption[`Default Title`]

  try {
    await fetch(window.Shopify.routes.root + 'cart/clear.js', {
      method: 'POST'
    }) 
    const response = await setCart([{id: selectedVariant.id}])
    prodContainerEl.classList.remove('is-loading')
    isLoading = false

    if(response.status === 'ERROR'){
      console.log(response)
      sessionStorage.setItem('cart-error', `Sorry, we're not currently taking any more deposits.`)
      location.reload()
    }
  } catch (error) {
    prodContainerEl.classList.remove('is-loading')
    isLoading = false
    console.log(error)
  }
}

window.addEventListener('load', () => {
  setTimeout(() => {
    const error = sessionStorage.getItem('cart-error')
    sessionStorage.removeItem('cart-error')
  
    if(error){
      showError(error)
    }
  }, 100);

})

if(buyButtonEl){
  if(isDeposit){
    buyButtonEl.addEventListener('click', submitDeposit)
  } else {
    buyButtonEl.addEventListener('click', submit)
  }
}


updateOptions()
prodContainerEl.classList.add('is-ready')

const productSections = qsa('.product-section')

productSections.forEach(section => {
  if(section.classList.contains('color-off-white')){
    section.parentNode.classList.add('color-off-white')
  }
  if(section.classList.contains('color-white')){
    section.parentNode.classList.add('color-white')
  }
  if(section.classList.contains('color-warm')){
    section.parentNode.classList.add('color-warm')
  }
})